import { isNonNullable } from "./typeguards";

export function runIfDefined<T, R>(
  v: T | undefined | null,
  block: (v: NonNullable<T>) => R | undefined
): R | undefined {
  if (isNonNullable(v)) return block(v);
  return;
}
